/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var homepage_banner_video_pause = document.getElementById('homepage-banner-video-control');

  if(homepage_banner_video_pause) {
    var homepage_banner_video = document.getElementById('homepage-banner-video');

    homepage_banner_video_pause.addEventListener('click', (e) => {
      e.preventDefault();

      var is_paused = 'false';

      if (homepage_banner_video.paused) {
        homepage_banner_video.play();
        homepage_banner_video_pause.setAttribute('data-state', 'play');
        homepage_banner_video_pause.querySelector('.label').textContent = 'Pause Video';
      } else {
        is_paused = 'true';
        homepage_banner_video.pause();
        homepage_banner_video_pause.setAttribute('data-state', 'pause');
        homepage_banner_video_pause.querySelector('.label').textContent = 'Play Video';
      }

      document.cookie = 'TECHomepageBannerVideoPaused=' + is_paused + '; max-age='+(12*60*60)+'; SameSite=lax; path=/';
    });
  }
}());
